<template>

    <div class="menu-wrapper has-text-grey-dark">

        <div class="menu-group" style="background-color:#bfb5b2;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Static Values</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/number')" title="A specific number value">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-hashtag"></i></p>
                                <p class="is-size-7 has-text-weight-bold">NUMBER</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/date')" title="A specific date (typical calendar date)">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-calendar-day"></i></p>
                                <p class="is-size-7 has-text-weight-bold">DATE</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/text')" title="A text value (any word, letter, sentence, etc.)">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-font"></i></p>
                                <p class="is-size-7 has-text-weight-bold">TEXT</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/boolean')" title="A boolean value (aka. a True or False value)">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-right-left"></i></p>
                                <p class="is-size-7 has-text-weight-bold">BOOLEAN</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/empty')" title="Represents an empty value">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-0"></i></p>
                                <p class="is-size-7 has-text-weight-bold">EMPTY</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


        <div class="menu-group" style="background-color:#9b9998;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Extractions</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('values/date-time-unit')" title="Extract the year/month/day/hour/minute from a date">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-calendar-week"></i></p>
                                <p class="is-size-7 has-text-weight-bold">DATE/TIME UNIT</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>


</template>

<script>
export default {
    name: 'MenuTabModifiers',
    props: {
        triggerType: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        selected(type) {
            this.$emit('selected', type)
        }
    }
}
</script>

<style scoped lang="scss">
.menu-wrapper {
    overflow-x: auto;
    display: flex;
}
.menu-group {
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;

    .menu-group-title {
        width:100%;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .menu-group-items {
        overflow-x: auto;
        display: flex;
    }

    &:first-child {
        margin-left: auto;
    }
    &:last-child {
        margin-right: auto;
    }
}
.menu-item {
    margin: 0 10px;

    & > div {
        padding: 0;
        height: 100px;
        width: 100px;
    }
}
.big-pretty-button {
    border: 0.5px solid #4a4a4a;
}
</style>
